// Giai đoạn đầu tư
export default {
  PrepareInvest: 1, // 'Giai đoạn chuẩn bị đầu tư',
  PerformInvest: 2, // 'Giai đoạn thực hiện đầu tư',
  EndInvest: 3, // 'Giai đoạn kết thúc xây dựng, đưa dự án vào khai thác sử dụng',
  Costs: 4, // 'Chi phí Ban quản lý dự án',
};
